import * as React from "react";
import { Path, G, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CZIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CZ" {...props}>
    <G id="flag">
      <G id="contents">
        <Path
          id="background"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="#E31D1C"
        />
        <G id="Object">
          <Mask
            id="mask0_5428_9934"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="16"
            height="12"
          >
            <Path
              id="background_2"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V12H16V0H0Z"
              fill="white"
            />
          </Mask>
          <G mask="url(#mask0_5428_9934)">
            <Path
              id="top"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 -1V6H16V-1H0Z"
              fill="#F7FCFF"
            />
          </G>
        </G>
        <Path
          id="triangle"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12L9 6L0 0Z"
          fill="#3D58DB"
        />
        <Mask
          id="mask1_5428_9934"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="9"
          height="12"
        >
          <Path
            id="triangle_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V12L9 6L0 0Z"
            fill="white"
          />
        </Mask>
        <G mask="url(#mask1_5428_9934)"></G>
      </G>
    </G>
  </Icon>
);
